import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "workingScheduleCalendar" }
const _hoisted_2 = { class: "header flex items-center justify-between mb-[20px]" }
const _hoisted_3 = {
  id: "monthYear",
  class: "block font-medium text-black dark:text-white"
}
const _hoisted_4 = { class: "calendar grid grid-cols-7 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        id: "prevBtn",
        class: "transition-all text-black bg-gray-100 dark:text-white dark:bg-[#172036] flex items-center justify-center rounded-full w-[30px] h-[30px] hover:bg-primary-500 hover:text-white",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeMonth(-1)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("i", { class: "material-symbols-outlined" }, " chevron_left ", -1)
      ])),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentDate), 1),
      _createElementVNode("button", {
        id: "nextBtn",
        class: "transition-all text-black bg-gray-100 dark:text-white dark:bg-[#172036] flex items-center justify-center rounded-full w-[30px] h-[30px] hover:bg-primary-500 hover:text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMonth(1)))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "material-symbols-outlined" }, " chevron_right ", -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"days\">Sun</div><div class=\"days\">Mon</div><div class=\"days\">Tue</div><div class=\"days\">Wed</div><div class=\"days\">Thu</div><div class=\"days\">Fri</div><div class=\"days\">Sat</div>", 7)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarDays, (day, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["date", [day.class]]),
          key: index
        }, _toDisplayString(day.date), 3))
      }), 128))
    ])
  ]))
}